module.exports = __webpack_public_path__ + "static/media/YM58_6.366bb2bf.jpg";